export var LibColor;
(function (LibColor) {
    LibColor["white"] = "#ffffff";
    LibColor["black"] = "#000624";
    LibColor["blue80"] = "#084ebd";
    LibColor["blue90"] = "#0f62e6";
    LibColor["blue100"] = "#116dff";
    LibColor["blue120"] = "#5999ff";
    LibColor["dark10"] = "#333853";
    LibColor["dark30"] = "#000624";
    LibColor["dark40"] = "#333853";
    LibColor["sky100"] = "#a8caff";
    LibColor["sky110"] = "#d6e6fe";
    LibColor["sky120"] = "#e7f0ff";
    LibColor["sky130"] = "#f4f7ff";
    LibColor["sky150"] = "#f4f7ff";
    LibColor["grey50"] = "#333853";
    LibColor["grey70"] = "#868aa5";
    LibColor["grey100"] = "#acafc4";
    LibColor["grey110"] = "#cfd1dc";
    LibColor["grey130"] = "#dfe5eb";
    LibColor["grey150"] = "#eceff3";
    LibColor["grey190"] = "#f7f8f8";
    LibColor["silver100"] = "#dfe5eb";
    LibColor["silver70"] = "#acafc4";
    LibColor["orange50"] = "#df4d00";
    LibColor["orange70"] = "#fb7d33";
    LibColor["orange100"] = "#ff7d38";
    LibColor["orange120"] = "#ff9a48";
    LibColor["orange140"] = "#e7a600";
    LibColor["orange150"] = "#ffb700";
    LibColor["orange180"] = "#ffe2a5";
    LibColor["red100"] = "#b81206";
    LibColor["red120"] = "#d0180b";
    LibColor["red140"] = "#e62214";
    LibColor["red150"] = "#ff6d63";
    LibColor["red190"] = "#f69891";
    LibColor["green60"] = "#1d8649";
    LibColor["green90"] = "#229954";
    LibColor["green100"] = "#25a55a";
    LibColor["green140"] = "#51b77b";
    LibColor["green180"] = "#87cea5";
    LibColor["brown40"] = "#867650";
    LibColor["brown100"] = "#c68801";
    LibColor["yellow100"] = "#ffce00";
    LibColor["yellow180"] = "#fef0ba";
    LibColor["purple80"] = "#8e1dd1";
    LibColor["purple100"] = "#9a27d5";
    LibColor["purple120"] = "#c161f0";
    LibColor["cornflower"] = "#6544f9";
    LibColor["teal"] = "#17b0e2";
    LibColor["turquoise"] = "#3d9fa1";
    LibColor["rose"] = "#d04091";
})(LibColor || (LibColor = {}));
//# sourceMappingURL=colors-map.js.map